// Riconosce i link video di YouTube e Vimeo in tutti i formati comuni e restituisce
// cosa serve per mostrarli: id, indirizzo da incorporare e anteprima.
//   YouTube: watch?v=, youtu.be/, shorts/, embed/, live/, m., music., nocookie, con parametri (&t=, ?si=, &list=)
//   Vimeo:   vimeo.com/123, vimeo.com/canale/123, player.vimeo.com/video/123
export const parseVideo = (raw) => {
  const url = (raw || '').trim();
  if (!url) return null;
  let u;
  try {
    u = new URL(url.startsWith('http') ? url : `https://${url}`);
  } catch (_) {
    return null;
  }
  const host = u.hostname.replace(/^www\.|^m\.|^music\./, '');

  let yt = null;
  if (host === 'youtu.be') yt = u.pathname.slice(1).split('/')[0];
  else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    yt = u.searchParams.get('v');
    if (!yt) {
      const m = u.pathname.match(/^\/(?:shorts|embed|live|v)\/([^/?#]+)/);
      if (m) yt = m[1];
    }
  }
  if (yt && /^[a-zA-Z0-9_-]{11}$/.test(yt)) {
    return {
      provider: 'youtube',
      id: yt,
      embedUrl: `https://www.youtube-nocookie.com/embed/${yt}?autoplay=1&rel=0&modestbranding=1&playsinline=1`,
      thumbnail: `https://img.youtube.com/vi/${yt}/hqdefault.jpg`,
      thumbnailHd: `https://img.youtube.com/vi/${yt}/maxresdefault.jpg`,
    };
  }

  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const m = u.pathname.match(/(\d{6,})/);
    if (m) {
      return {
        provider: 'vimeo',
        id: m[1],
        embedUrl: `https://player.vimeo.com/video/${m[1]}?autoplay=1&title=0&byline=0&portrait=0`,
        thumbnail: `https://vumbnail.com/${m[1]}.jpg`,
        thumbnailHd: `https://vumbnail.com/${m[1]}.jpg`,
      };
    }
  }
  return null;
};
